module.exports = __webpack_public_path__ + "static/media/ic-empty-list.b6429a7c.svg";